'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { PortableText, type PortableTextComponents } from '@portabletext/react';
import type { ServiceCardDescription as ServiceCardDescriptionValue } from '@/lib/service-card-description';
const components: PortableTextComponents = {
  block: {
    normal: ({
      children
    }) => <>{children}</>
  },
  marks: {
    link: ({
      children,
      value
    }) => {
      const href = typeof value?.href === 'string' ? value.href : '#';
      const isInternal = value?.internal === true || href.startsWith('/') && !href.startsWith('//');
      if (isInternal) {
        return <Link href={href} className="underline underline-offset-2 hover:text-accent">
                        {children}
                    </Link>;
      }
      return <a href={href} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-accent">
                    {children}
                </a>;
    },
    strong: ({
      children
    }) => <strong className="font-medium">{children}</strong>,
    em: ({
      children
    }) => <em>{children}</em>
  }
};
type Props = {
  value: ServiceCardDescriptionValue;
  className?: string;
};
export default function ServiceCardDescription(t0) {
  const $ = _c(5);
  const {
    value,
    className
  } = t0;
  if (!value?.length) {
    return null;
  }
  let t1;
  if ($[0] !== value) {
    t1 = <PortableText value={value} components={components} />;
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className || $[3] !== t1) {
    t2 = <div className={className}>{t1}</div>;
    $[2] = className;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}